module.exports = __webpack_public_path__ + "img/REPLACEMENT-WORK-IN-CAFE-PARK-ETC2-2048x801.26615d04.jpg";